<app-header />
<main class="mbs-container">
  <div class="mbs-container-inner">
    <div class="mbs-container-content">
      <div class="mbs-page">
        <div class="mbs-page_content">
          <router-outlet />
        </div>
        <mbs-toasts data-position="bottom-right" />
        <mbs-alert-container />
      </div>
    </div>
    <app-footer/>
  </div>
</main>

<ng-template #exportJobTransferredTRef>
  <ng-container *ngTemplateOutlet="jobTransferredTRef; context: { $implicit: TemplateType.Export }" />
</ng-template>

<ng-template #backupJobTransferredTRef>
  <ng-container *ngTemplateOutlet="jobTransferredTRef; context: { $implicit: TemplateType.Backup }" />
</ng-template>

<ng-template #restoreJobTransferredTRef>
  <ng-container *ngTemplateOutlet="jobTransferredTRef; context: { $implicit: TemplateType.Restore }" />
</ng-template>

<ng-template #deleteJobTransferredTRef>
  <ng-container *ngTemplateOutlet="jobTransferredTRef; context: { $implicit: TemplateType.Delete }" />
</ng-template>

<ng-template #jobTransferredTRef
             let-templateType>
  {{ 'common.transferred-job.' + templateType | i18next: { format: 'capitalize' } }}

  <a [routerLink]="[prefix + RoutePath.TaskManager]"
     class="d-inline">
    {{ 'common.transferred-job.taskManager' | i18next: { format: 'title' } }}
  </a>
</ng-template>
